import { RadioButton } from "Components/Form/RadioButton";
import { useTexts } from "Components/TextContext";
import { Button } from "Components/TextContext/commonComponentEnums";
import { TextComponentNameLevel1 } from "Components/TextContext/textConstants";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";

interface Props {
  formProps: FormikProps<any>;
}

export const BuildingMaterial = ({ formProps }: Props): React.ReactElement => {
  const { getText, getRadioOptions } = useTexts();
  const hintProps = {
    maxLines: 4,
    readLessLabel: getText(Button.READ_LESS),
    readMoreLabel: getText(Button.READ_MORE),
  };

  return (
    <RadioButton
      name="fireResistantBuildingMaterial"
      id="fireResistantBuildingMaterial"
      label={getText("housecontentsform.label.fireresistantbuildingmaterial")}
      options={getRadioOptions(
        TextComponentNameLevel1.HOUSE_CONTENTS,
        "fireResistantBuildingMaterial",
        {},
        hintProps,
      )}
      direction="vertical"
      error={getError("fireResistantBuildingMaterial", formProps)}
    />
  );
};
